import { DateRadioPicker } from '@/components/dateRadioPicker/DateRadioPicker';
import { DateRadioPickerDayState, DateRadioPickerOption } from '@/components/dateRadioPicker/dateRadioPicker.types';
import { OptimiserRequest } from '@/services/optimiser/useSendOptimseRequest';
import { useTemplatesForLocation } from '@/services/shared/useTemplatesForLocation';
import React, { FC, useCallback, useMemo } from 'react';

interface OptimiserSelectTemplatesProps {
  existingPattern: OptimiserRequest[];
  setPatternCallback: (newPattern: OptimiserRequest[]) => void;
}

const OptimiserSelectTemplates: FC<OptimiserSelectTemplatesProps> = ({ existingPattern, setPatternCallback }) => {
  const { templateOptions } = useTemplatesForLocation();

  const dateRadioOptions: DateRadioPickerOption[] = useMemo(() => {
    return templateOptions.map(temp => {
      const option: DateRadioPickerOption = {
        name: temp.name,
        value: temp.id,
        color: temp.color
      };
      return option;
    });
  }, [templateOptions]);

  const pickerState: DateRadioPickerDayState[] = useMemo(() => {
    return existingPattern.map(p => ({ date: p.date, option: dateRadioOptions.find(d => d.value === p.templateId) }));
  }, [dateRadioOptions, existingPattern]);

  const updatePickerState = useCallback((newState: DateRadioPickerDayState[]) => {
    const newRequest = newState.map(p => ({
      date: p.date,
      templateId: p.option?.value
    }));

    setPatternCallback(newRequest);
  }, []);

  return (
    <DateRadioPicker options={dateRadioOptions} selectedValues={pickerState} setSelectedValues={updatePickerState} />
  );
};

export default React.memo(OptimiserSelectTemplates);
